import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { UserDataService } from './core/services/user-data.service';
import { role } from './shared/constants/role-enum';


@Component({
    selector: 'app-landing',
    template: '',
    styles: ['']
})
export class AppLandingComponent implements OnInit, OnDestroy {
    subscriptions: Subscription;
    constructor(private _userDataService: UserDataService, private _router: Router) { }
    ngOnInit(): void {
        this.subscriptions = this._userDataService.userDetails$.subscribe(userData => {
            if (userData && userData.roleId) {
                const landingRoute = this._userDataService.getLandingPageBasedOnRole(userData.roleId);
                this._router.navigate([landingRoute], {
                    queryParamsHandling: 'preserve'
                });
            }
        });
    }

    ngOnDestroy(): void {
        if (this.subscriptions) {
            this.subscriptions.unsubscribe();
        }
    }
}
